<template>
    <div class="artcle-right">
        <div class="search-page">
            <Search class="searchWidth" @inputKey="inputKey" :Newkeywords="Newkeywords"></Search>
            <el-button class="expertJoin"  round @click="company()" >+专家入驻</el-button>
        </div>
        <div v-for="item in listarticle" :key="item.id">
            <div class="exper-div" @click="handleDetail(item)">
               
                <div class="experImageWidth">
                    <img :src="item.firstFile.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                </div>
                <div class="expertInfo">
                    <div class="info-top">
                        <div class="infoTitle">
                            <p class="title-p">{{ item.name }}</p>
                            <p class="time-p">{{ item.title }}</p>
                        </div>
                        <div>
                            <el-button type="primary" round @click.stop="VSPay(item)">在线咨询</el-button>
                        </div>
                        
                    </div>
                    <div class="info-bottom">
                        <p>所属行业：{{ item.industrys_name }}</p>
                        <p>所属领域：{{ item.fields_name }}</p>
                        <p>所属专项：{{ item.specials_name }}</p>
                        <p>所属供需：{{ item.supplys_name }}</p>
                    </div>
                </div>
            </div>
            <el-divider   ></el-divider>
        </div>
        <!-- <div >
            <div class="exper-div">
                <div class="experImageWidth"></div>
                <div class="expertInfo">
                    <div class="info-top">
                        <div class="experName">
                            <p class="title-p">叶咏宁</p>
                            <p class="time-p">中级工程师</p>
                        </div>
                        <div>
                            <el-button type="primary" round>在线咨询</el-button>
                        </div>
                        
                    </div>
                    <div class="info-bottom">
                        <p>擅长方向：环保检测</p>
                        <p>技术领域：环保检查</p>
                        <p>任职机构：安众皓宁有限公司</p>
                    </div>
                </div>
            </div>
            <el-divider   ></el-divider>
        </div>
        <div >
            <div class="exper-div">
                <div class="experImageWidth"></div>
                <div class="expertInfo">
                    <div class="info-top">
                        <div class="experName">
                            <p class="title-p">叶咏宁</p>
                            <p class="time-p">中级工程师</p>
                        </div>
                        <div>
                            <el-button type="primary" round>在线咨询</el-button>
                        </div>
                        
                    </div>
                    <div class="info-bottom">
                        <p>擅长方向：环保检测</p>
                        <p>技术领域：环保检查</p>
                        <p>任职机构：安众皓宁有限公司</p>
                    </div>
                </div>
            </div>
            <el-divider   ></el-divider>
        </div> -->
        <div class="pagination">
            <el-pagination
                :hide-on-single-page="hideOnSinglePage"
                :page-size="20"
                :pager-count="widthNew?11:5"
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog
            width="20%"
            title="扫码支付"
            :visible.sync="dialogFormEdit"
            customClass="messageDialog"
            >
            <div slot="footer" class="dialog-footer">
            <!-- <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="edit">确 定</el-button> -->
                <div id="canvas" style="padding-bottom: 20px;">

                </div>
            </div>
        </el-dialog>  
    </div>
</template>
<script>
import Search from "../search/index.vue"
import QRCode from 'qrcodejs2'
export default({
    props: ['type','cateId','recommendIds','wacthMenu','Newkeywords','channelType'],
    data(){
        return{
            total: 0,
            hideOnSinglePage: true,
            currentChange: 1,
            key:'',
            listarticle: [],
            widthNew: false,
            vsfrom: 'native',
            dialogFormEdit: false
        }
    },
    components: {
        Search,
    },
    watch: {
        cateId(newVal,oldVal){
            console.log("channelType---------");
            console.log(newVal);
            if(newVal != ''){
                if(this.channelType == 'company'){
                    let data = {
                        pageNum: 1,
                        pageSize: 20,
                        industry: '',
                        field: '',
                        special: '',
                        supply: '',
                        name: '',
                        recommendIds: newVal,
                    }
                    this.getListArry(data)
                }else if(this.channelType == 'industry'){
                    let data = {
                        pageNum: 1,
                        pageSize: 20,
                        industry: newVal,
                        field: '',
                        special: '',
                        supply: '',
                        name: '',
                        recommendIds: '',
                    }
                    this.getListArry(data)
                }else if(this.channelType == 'special'){
                    let data = {
                        pageNum: 1,
                        pageSize: 20,
                        industry: '',
                        field: '',
                        special: newVal,
                        supply: '',
                        name: '',
                        recommendIds: '',
                    }
                    this.getListArry(data)
                }else if(this.channelType == 'field'){
                    let data = {
                        pageNum: 1,
                        pageSize: 20,
                        industry: '',
                        field: newVal,
                        special: '',
                        supply: '',
                        name: '',
                        recommendIds: '',
                    }
                    this.getListArry(data)
                }else if(this.channelType == 'supply'){
                    let data = {
                        pageNum: 1,
                        pageSize: 20,
                        industry: '',
                        field: '',
                        special: '',
                        supply: newVal,
                        name: '',
                        recommendIds: '',
                    }
                    this.getListArry(data)
                }
            }else{
                let data = {
                    pageNum: 1,
                    pageSize: 20,
                    industry: '',
                    field: '',
                    special: '',
                    supply: '',
                    name: '',
                    recommendIds: '',
                }
                this.getListArry(data)
            }
           
        },
     
        wacthMenu(newVal,oldVal){
            
            let data = {
                pageNum: 0,
                pageSize: 10,
                recommendIds: this.recommendIds,
                keywords: this.Newkeywords,
            }
            this.getListArryMenu(data)
        },
        recommendIds(newVal,oldVal){
            let data = {
                pageNum: 0,
                pageSize: 10,
                recommendIds: newVal,
                keywords: this.Newkeywords,
            }
            this.getListArry(data)
        }
    },
    methods:{
        VSPay(item){
            var user_id = item.user_id
            if(user_id == 0){
                this.$notify({
                    title: '提示',
                    message: '专家未绑定会员',
                    type: 'warning',
                })
                return false
            }
            
            
           
          
       
            var data = {
                expert_id: item.id,
                pay_type: this.vsfrom
            }
            this.$store.dispatch('expert/expertPay',data)
                .then(res => {
                    if(res.ok){
                        if(res.msg == 'paysuccess'){
                            this.$router.push({
                                path: '/session/chatitemExpert',
                                query: {
                                    chat_type: 'chat_expert',
                                    to_user_id: user_id,
                                    order_no: res.data
                                }
                            })
                        }else{
                            document.getElementById( 'canvas' ).innerHTML =  '' ;
                            this.dialogFormEdit = true
                            
                            var qrcode = new QRCode('canvas', {
                                text: res.data.code_url,
                                width: 150,
                                height: 150,
                                colorDark : '#000000',
                                colorLight : '#ffffff',
                                correctLevel : QRCode.CorrectLevel.H
                            });
                            
                            let  timer = setInterval(() => {
                                this.getPaystatus(res.data.order_no,timer)
                            }, 5000)
                        }
                    }else{
						if(res.data == 'notlogin'){
                            this.$router.push({
                                path: '/login',
                            })
                            this.$notify({
                                title: '提示',
                                message: '请选登录再咨询',
                                type: 'error',
                            })
						}else if(res.data != ''){
                            this.$router.push({
                                path: '/session/chatitemExpert',
                                query: {
                                    chat_type: 'chat_expert',
                                    to_user_id: user_id,
                                    order_no: res.data
                                }
                            })
						}else{
                            this.$notify({
                                title: '提示',
                                message: res.msg,
                                type: 'warning',
                            })
						}
					}
                })

        },
        getPaystatus(orderNo,timer){
            setTimeout(()=>{
                let data = {
                    order_no: orderNo
                }
                this.$store.dispatch('personal/getPaystatus',data)
                    .then(res =>{
                        if(res.data.ispay == 1){
                            clearInterval(timer)
                             this.$notify({
                                title: '提示',
                                message: '支付成功',
                                type: 'success'
                            })

                            this.$router.push({
                                path: '/session/chatitemExpert',
                                query: {
                                    chat_type: 'chat_expert',
                                    to_user_id: this.companyInfo.user_id,
                                    order_no: orderNo
                                }
                            })

                        }
                    })
                
                
            }, 0)
         },

        //   查询专家列表
        getListArry(data){
            this.listarticle = []
            this.$store.dispatch('menu/listexpert',data)
                .then(res => {
                
                    if(res.ok){
                        this.listarticle = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                    

                }).catch(err => {
                    console.log(err);
                })
        },
        getListArryMenu(data){
            this.$store.dispatch('menu/listexpertMenu',data)
                .then(res => {
                
                    if(res.ok){
                        this.listarticle = res.data.items
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                    

                }).catch(err => {
                    console.log(err);
                })
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            this.currentChange = val
            let data = {
                pageNum: val,
                pageSize: 20,
                industry: '',
                field: '',
                special: '',
                supply: '',
                name: '',
                recommendIds: ''
            }
            
            this.getListArry(data)
        },
        inputKey(val){
            this.$emit('GetNewkeywords',val)
            this.Newkeywords = val
            if(this.type != 2){
                console.log("ann");
                console.log(val);
                this.key = val
                let data = {
                    pageNum: 1,
                    pageSize: 20,
                    industry: this.cateId,
                    field: '',
                    special: '',
                    supply: '',
                    name: val,
                    recommendIds: ''
                }

                this.getListArry(data)
            }else if(this.type == 2){
                let data = {
                    pageNum: 0,
                    pageSize: 10,
                    recommendIds: this.recommendIds,
                    keywords: val,
                }
                this.getListArryMenu(data)
            }
        },
        handleDetail(item){
            const { href } = this.$router.resolve({
                path: "/detailInfo",
                query: {
                    id: item.id,
                }
            });
            window.open(href, '_blank');
        },
        company(){
            this.$router.push({
                path: '/expertJoin'
            })
        }

    },
    mounted(){
    
        if(this.type == 1){
            let data = {
                pageNum: 1,
                pageSize: 20,
                industry: '',
                field: '',
                special: '',
                supply: '',
                name: '',
            }
            
            this.getListArry(data)
        }else if(this.type == 2){
            this.key = this.Newkeywords
            let data = {
                pageNum: 0,
                pageSize: 10,
                recommendIds: this.recommendIds,
                keywords: this.Newkeywords,
            }
            console.log("****************");
            console.log(data);
            this.getListArryMenu(data)
        }
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
    }

})
</script>
<style scoped>


.artcle-right{
    margin-left: 5px;
    background: #fff;
    padding: 15px 15px ;
}
.exper-div{
    display: flex;
    height: 210px;
    justify-content: flex-start;
}


.exper-div .experImageWidth{
    width: 180px;
    height: 210px;
}
.exper-div .expertInfo{
    width: 700px;height: 210px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 18px;
}
.exper-div img{
    width: 180px;height: 210px;
    line-height: 18px;
}
.exper-div .expertInfo{
    margin-left: 20px;
    
    
}
.exper-div .expertInfo .el-button{
    background: #00a8a8;
    border: 1px solid #00a8a8;
}


.pagination{
    margin-top: 40px;
    text-align: right;
}
.info-bottom{
    font-size: 16px;
    color: #bbb;
    margin-top: 0px;
    line-height: 30px;
}
.info-bottom p{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.el-divider{
  background-color: #f2f2f2;
}
.search-page{
    display: flex;
    justify-content: space-between;
}
.search-page .el-button{
    height: 42px;
    background: #ff9828;
    border: 1px solid #ff9828;
    color: #fff;
}
@media screen and (min-width: 541px) {
    .searchWidth{
        /* margin-bottom: 40px; */
        width: 600px;
    }
    .exper-div div{
        width: 900px;
        cursor: pointer;
        margin-bottom: 10px;

    }
    .title-p{
        width: 580px;height: 40px;
        font-size: 24px;
    }
    .time-p{
        font-size: 16px;
        color: #bbbbbb;
        text-align: left;
        align-items: center;
    }
    .info-top{
        display: flex;
        justify-content: space-between;
        height: 80px;
    }
}
@media screen and (max-width: 540px) {
    .artcle-right{
        width: 95%;
        margin-left: 0px;
        margin: 10px auto;
        padding: 15px 0px;
    }

   
    .searchWidth{
        padding-left: 8px;
        /* margin-bottom: 40px; */
        width: 65%
    }
    .expertJoin{
        float: right;
    }
    .search-page .el-button{
        margin-right: 8px;
    }
    .exper-div{
        width: 95%;height: 180px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    /* .exper-div div{
        width: 98%;

    } */
    .exper-div .experImageWidth{
        width: 40%;height: 180px;
    }
    .exper-div .expertInfo{
        width: 60%;height: 180px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 18px;
        margin-left: 5px;
    }
    .exper-div img{
        width: 25%;height: 180px;
        line-height: 18px;
    }

    .info-top{
        width: 98%;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 80px;
    }

    .title-p{
        height: 40px;
        font-size: 18px;
    }
    .infoTitle{
        width: 65%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .time-p{
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #bbbbbb;
        text-align: left;
        align-items: center;
    }
    .info-bottom{
        font-size: 14px;
    }
}
::v-deep .el-dialog .el-dialog__header {
    line-height: 0px !important;
}
::v-deep #canvas img{
    margin: auto !important;
}

::v-deep .el-dialog__body{
    padding: 10px 0 !important;
}
</style>

